import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnVideoComponent } from 'src/app/components/btns/btn-video/btn-video.component';
import { ProdutoVideoModal } from 'src/app/components/produto/produto-video-modal/produto-video-modal.component';
import { AppService } from 'src/app/services/app.service';
import { ApiService } from 'src/app/services/api.service';
import { PipeModule } from '../../pipe/pipe.module';

@NgModule({
  declarations: [
    BtnVideoComponent,
    ProdutoVideoModal
  ],
  entryComponents:[
    ProdutoVideoModal
  ],
  imports: [
    CommonModule,
    PipeModule
  ],
  providers:[
    AppService,
    ApiService
  ]
})
export class BtnModule { }
